import React from 'react';
import {QuestionTypeViewPropTypes} from '../../../shapes/index.mjs';
import QuestionText from '../../questions/QuestionText.jsx';
import {useIntl} from 'react-intl';
import {getMessageValue} from '../../../i18n/messageUtil';
import classNames from 'classnames';
import Input from '@ignitesales/react-input-debounced';

const TextInput = props => {
  const {className, valueChanged, question, value: {value = {}} = {}} = props;

  const intl = useIntl();
  const attributes = question?.attributes || {};
  const currentValue = value?.length > 0 ? value[0] : '';
  const placeholder = getMessageValue(intl.locale, `${question.appkey}.input.placeholder`);
  const classes = classNames(className, {
    textInput: true,
  });

  return (
    <section className={classes}>
      <QuestionText question={question} />
      <div className="textInput__container">
        <Input
          type={attributes?.type || 'text'}
          onChange={valueChanged}
          delay={attributes?.delay || 500}
          placeholder={placeholder}
          validateOnBlur={attributes?.validateOnBlur}
          value={currentValue}
        />
      </div>
    </section>
  );
};
TextInput.propTypes = QuestionTypeViewPropTypes;

export default TextInput;
